import { Element } from "@/scripts/extends";

class Body extends Element {}

const body = new Body(document.body);

export default body;
